// extracted by mini-css-extract-plugin
module.exports = {"container":"GameStatusBar_container__2Sg7l","level":"GameStatusBar_level__2GEqd","lives_container":"GameStatusBar_lives_container__5pLbL","icon":"GameStatusBar_icon__wJ37z"};